import { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SideNavigation from '../SideNavigation/SideNavigation'
import ManagePeople from '../ManagePeople/ManagePeople'
import './my-company-main.scss'
import { Configuration } from '../../types/Configuration';
import WelcomeBaner from '../WelcomeBaner/WelcomeBaner';
import Sticky from 'react-stickynode';
import agent from '../../api/Agent';
import * as constants from '../../helpers/constants'
import CompanyMasterData from '../CompanyMasterData/CompanyMasterData';
import { Element } from 'react-scroll';
import PaymentMethods from '../PaymentMethods/PaymentMethods';
import Invoices from '../Invoices/Invoices';
import jwt_decode from 'jwt-decode';

type Props = {
    selectedLanguage: string,
    accessToken: string,
    tokenIsProvided: boolean,
    configuration: Configuration,
    isMobile: boolean
}

interface MyCompanyRoutParams {
    companyId: string
    companyName: string
}

function MyCompanyMain(props: Props) {

    const [managePeopleAreaHasError, setState] = useState(false);
    const [userTeam, setUserTeam] = useState('');
    const [companyType, setCompanyType] = useState('');
    const [mainCompanyId, setMainCompanyId] = useState('');
    const [iframeUrl, setIframeUrl] = useState('');

    let { companyId, companyName } = useParams<MyCompanyRoutParams>();
    companyName = decodeURIComponent(companyName);

    useEffect(() => {
        agent.getUserTeam(companyId).then(userTeamId => {
            setUserTeam(userTeamId)
        });
        agent.getCompanyType(companyId).then(companyType => {
            setCompanyType(companyType);
        });
        agent.getInvoiceIframeUrl(companyId).then(iframeUrl => {
            setIframeUrl(iframeUrl);
        });

        setMainCompanyId(getClaim("Profile_CompanyId"))
    }, []);

    function getClaim(claimName: string) : string {
        let mainCompanyId: string = (jwt_decode(props.accessToken) as any)[claimName];
        return mainCompanyId;
    }

    function setManagePeopleAreaErrorState(managePeopleAreaErrorState: boolean) {
        setState(managePeopleAreaErrorState);
    }

    const getClassManagePeopleArea = (hasError: boolean) => `component-container ${hasError ? "general-area error" : "general-area"}`;

    const stickyTop = (
        document.getElementsByClassName('dw-main-menu')[0]?.clientHeight
        + document.getElementsByClassName('dw-breadcrumbs')[0]?.clientHeight
        + 20
    );

    const isAdminOrManager = userTeam === constants.ADMIN_TEAM_ID || userTeam === constants.MANAGEMENT_TEAM_ID;

    const isMainCompany = mainCompanyId === companyId;

    return (
        <div className='dw-container'>
            <div id="SideMenu" className='dw-side-menu'>
                {!props.isMobile ?
                    <Sticky top={stickyTop} bottomBoundary="#sticky-break">
                        <SideNavigation {...props} companyName={companyName} userTeam={userTeam} companyType={companyType} isMobile={props.isMobile} isMainCompany={isMainCompany} showInvoices={!!iframeUrl} />
                    </Sticky> :
                    <SideNavigation {...props} companyName={companyName} userTeam={userTeam} companyType={companyType} isMainCompany={isMainCompany} showInvoices={!!iframeUrl} />
                }
            </div>
            <div className='dw-main-body'>
                <div className='dw-main-body-content'>
                    <div className='my-company-welcome-baner-area'><WelcomeBaner companyName={companyName} /></div>
                    <Fragment>
                        {<Element name="company-master-data" className="">
                            <CompanyMasterData
                                {...props}
                                companyId={companyId}
                                onLoadCallback={() => true}
                                onErrorCallback={() => false}>
                            </CompanyMasterData>
                        </Element>}
                    </Fragment>

                    {isAdminOrManager ? <div id="people-area" className={getClassManagePeopleArea(managePeopleAreaHasError)}>
                        <ManagePeople
                            {...props}
                            companyId={companyId}
                            onLoadCallback={() => setManagePeopleAreaErrorState(false)}
                            onErrorCallback={() => setManagePeopleAreaErrorState(true)}
                        />
                    </div> : null}

                    {props.configuration.shouldShowPaymentMethods
                        && userTeam === constants.ADMIN_TEAM_ID
                        && (companyType === constants.COMPANY_TYPE.DIRECT_CUSTOMER || companyType === constants.COMPANY_TYPE.PARTNER)
                        && <Element name="payment-methods" className="manage-people-area">
                            <PaymentMethods {...props} companyId={companyId} onLoadCallback={() => true} onErrorCallback={() => false} />
                        </Element>
                    }

                    {props.configuration.shouldShowInvoices
                        && userTeam === constants.ADMIN_TEAM_ID
                        && isMainCompany
                        && !!iframeUrl
                        && <Element id="invoices-area" className="invoices-area">
                                <Invoices
                                    iframeUrl={iframeUrl}
                                />
                            </Element> 
                    }
                </div>
                <div id="sticky-break"></div>
            </div>
        </div>
    )
}

export default MyCompanyMain;